import React from 'react';
import AttachmentButtonDownload from "../blocks/buttons/download";
import {AttachFileMode} from "../../const";
import Attachment from "../../../../model2/attachment/attachment";

// const debug = "AttachmentViewNoPreview"
const debug = false

type Props = {
    attachment        : Attachment
    mode              : AttachFileMode
    onPreview?        : callback
    onRemove?         : callback
    onAddToMessage?   : callback
    showRemoveButton? : boolean;
}

export default function AttachmentViewNoPreview(props: Props) {

    debug && console.log(debug, "render()", props)

    const onRemoveClick = () => {
        if (props.onRemove) props.onRemove(props.attachment)
    }

    const onAddToMessageClick = () => {
        if (props.onAddToMessage) props.onAddToMessage(props.attachment)
    }

    const {attachment} = props;
    const canInsertInMessage = !props.attachment.inMessageRTF && props.onAddToMessage

    return (
        <div className="ui5-attachment-no-preview">
            <div className="preview">
                <div className="ui5-ico-18 i5-file-code" />
            </div>
            <div className="details">
                <div className="file-name ui5-txt-less-important-tiny">
                    {props.attachment.name}
                </div>
            </div>

            {props.mode === 'edit' &&
            <div className="overlay-details">
                {!canInsertInMessage && <div className="file-size ui5-txt-not-important-tiny">{props.attachment.fileSizeFormatted}</div>}
                <div className="actions">
                    {attachment.inMessageRTF && <div className="ui5-ico-round red size-18 i5-delete" onClick={onRemoveClick} />}
                    {canInsertInMessage && <div className="ui5-link-tiny m-r-10" onClick={onAddToMessageClick}>Insert in Message</div>}
                    {!attachment.inMessageRTF && <div className="ui5-ico-round red i5-trash-alt" onClick={onRemoveClick} />}
                </div>
            </div>
            }


            {(props.mode === 'view' || props.mode === 'view-in-editor') &&
            <div className="overlay-details">
                <div className="file-size ui5-txt-not-important-tiny">
                    {props.attachment.fileSizeFormatted}
                </div>
                <div className="actions">
                    <AttachmentButtonDownload attachment={props.attachment}/>
                </div>
            </div>
            }

            {(props.mode === 'view-and-edit') &&
            <div className="overlay-details">
                <div className="file-size ui5-txt-not-important-tiny">
                    {props.attachment.fileSizeFormatted}
                </div>
                <div className="actions">
                    <div className="ui5-ico-round red i5-trash-alt m-r-5" onClick={onRemoveClick} />
                    <AttachmentButtonDownload attachment={props.attachment}/>
                </div>
            </div>
            }

            {props.mode === 'edit-in-editor' &&
            <div className="overlay-actions">
                <div className="ui5-ico-round red size-18 i5-delete" onClick={onRemoveClick} />
            </div>
            }

        </div>
    )
}
